import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouterState } from 'react-router-redux';
import { StoreState } from '../../../../../reducers';
import Utils from '../../../../../utils';
import { StyledMenuItem, MenuItemBadge } from '../styles';
import { MenuActionKeys } from '../../../actions';
import { GalleryInfosActionKeys } from '../../../../Gallery/actions';

export interface MenuItemRouteProps {
	dispatch: Dispatch<StoreState>;
	routing: RouterState;
	svgFileName: string;
	title: string;
	route: string;
	badge?: number;
}

class MenuItemRoute extends React.Component<MenuItemRouteProps, {}> {

	handleClick = () => {
		const { route, routing, dispatch } = this.props;
		const isActive = routing.locationBeforeTransitions.pathname === `/${route}`;

		if (isActive) {
			dispatch({ type: GalleryInfosActionKeys.FORCE_VIEW_UPDATE });
			dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
		}
	}

	render() {
		const { route, routing, svgFileName, title, badge } = this.props;
		const isActive = routing.locationBeforeTransitions.pathname === `/${route}`;

		return (
			<StyledMenuItem
				href={`#${route}${routing.locationBeforeTransitions.search}`}
				isActive={isActive}
				onClick={this.handleClick}
			>
				{Utils.getSvgIcon(svgFileName)}
				{title}
				{!!badge && <MenuItemBadge>{badge}</MenuItemBadge>}
			</StyledMenuItem>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { routing } = state;
	return { routing };
};

export default connect(mapStateToProps)(MenuItemRoute);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/MenuItem/Route/index.tsx